<script module lang="ts">
  import type { AccordionItemStoryblok } from "~/component-types-sb";
  export interface AccordionItemProps {
    blok: AccordionItemStoryblok;
  }
</script>

<script lang="ts">
  import { storyblokEditable } from "@storyblok/svelte";
  import { AccordionItem, AccordionTrigger, AccordionContent } from "@agapi/ui/accordion";
  import { RichText } from "../../../components";

  const { blok }: AccordionItemProps = $props();
</script>

<AccordionItem
  use={[[storyblokEditable, blok]]}
  title={blok.title}
>
  <AccordionTrigger />
  <AccordionContent>
    <RichText blok={blok} />
  </AccordionContent>
</AccordionItem>
